import con from '../../../../connection';
import { ApiPostCompanyArticlesMoveResponse } from './api-post-company-articles-move-response';

const path = '/move'

export const move = (url: string) => () => ({
  post: (param: { organization_code: string }) =>
    con.post<ApiPostCompanyArticlesMoveResponse>(url + path, param),
})